var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.565 6.564A6.564 6.564 0 0 0 8 0a6.55 6.55 0 0 0-6.564 6.497 6.565 6.565 0 0 0 3.953 6.091c.392.17.728.45.968.804l1.175 1.727c.225.33.711.33.936 0l1.175-1.727a2.25 2.25 0 0 1 .965-.802 6.566 6.566 0 0 0 3.957-6.026Z",
  fill: "#FE5F00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 10.69a4.126 4.126 0 1 0 0-8.252 4.126 4.126 0 0 0 0 8.253Z",
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 9.907a3.343 3.343 0 1 0 0-6.685 3.343 3.343 0 0 0 0 6.685Z",
  fill: "url(#c)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 10.488,
  y1: 9.053,
  x2: 2.258,
  y2: 0.823,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F92814"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 7.182,
  y1: 5.317,
  x2: 9.157,
  y2: 8.329,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9F7FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F0DDFC"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgPoint;